var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level-box"},[_c('img',{staticClass:"tag",attrs:{"src":require('@/assets/img/' + _vm.name + '.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }